var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFineArtsStars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.301 8.15013C13.7301 7.06193 15.2702 7.06193 15.6994 8.15013L16.9139 11.2295C17.7 13.2229 19.2779 14.8008 21.2714 15.5869L24.3507 16.8015C25.4388 17.2307 25.4388 18.7707 24.3507 19.1999L21.2714 20.4144C19.2779 21.2005 17.7 22.7784 16.9139 24.7719L15.6994 27.8512C15.2702 28.9393 13.7301 28.9393 13.301 27.8512L12.0865 24.7719C11.3003 22.7784 9.72237 21.2005 7.72897 20.4144L4.64965 19.1999C3.56145 18.7707 3.56145 17.2307 4.64965 16.8015L7.72897 15.5869C9.72237 14.8008 11.3003 13.2229 12.0865 11.2295L13.301 8.15013Z",
    stroke: "#141B34",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7168 3.64003C24.8777 3.23197 25.4553 3.23197 25.6162 3.64003L26.0716 4.79478C26.3665 5.5423 26.9582 6.13403 27.7057 6.42885L28.8605 6.88427C29.2685 7.04522 29.2685 7.62274 28.8605 7.78369L27.7057 8.23911C26.9582 8.53393 26.3665 9.12566 26.0716 9.87318L25.6162 11.0279C25.4553 11.436 24.8777 11.436 24.7168 11.0279L24.2614 9.87318C23.9665 9.12566 23.3748 8.53393 22.6273 8.23911L21.4725 7.78369C21.0645 7.62274 21.0645 7.04522 21.4725 6.88427L22.6273 6.42885C23.3748 6.13403 23.9665 5.5423 24.2614 4.79478L24.7168 3.64003Z",
    stroke: "#141B34",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineArtsStars);
export default __webpack_public_path__ + "static/media/fine-arts-stars.c241a95705cb82a30a030e7b495341aa.svg";
export { ForwardRef as ReactComponent };